// removed by extract-text-webpack-plugin
module.exports = {"nprogress-spinner":"nprogress-spinner___299Ka"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/app.less
// module id = 720
// module chunks = 37